import { render } from "./glob-filter-back.vue?vue&type=template&id=890b5558&scoped=true"
import script from "./glob-filter-back.vue?vue&type=script&lang=js"
export * from "./glob-filter-back.vue?vue&type=script&lang=js"

import "./glob-filter-back.vue?vue&type=style&index=0&id=890b5558&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-890b5558"]])

export default __exports__